import React from 'react';
import { Lock as LockIcon } from '@mui/icons-material';
import { CircleContainer, StyledBox, StyledLockIcon, TextContainer } from './UnlockConfirmation.styles';

const UnlockConfirmation = () => (
  <StyledBox>
    <CircleContainer>
      <StyledLockIcon>
        <LockIcon fontSize="large" />
      </StyledLockIcon>
    </CircleContainer>
    <TextContainer>
      <p>Are you sure you want to unlock this version?</p>
      <p>This will affect a final Allocation.</p>
    </TextContainer>
  </StyledBox>
);

export default UnlockConfirmation;
